// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AEgIEBHcUVGEym {
  padding: 4px 0 8px;
}
.dFag8JU1lt76jj {
  display: flex;
  flex-grow: 1;
  align-items: center;
  min-width: 0;
  margin-bottom: 4px;
  gap: 4px;
}
.qzn6ergg_M9Pzv .dFag8JU1lt76jj {
  margin-bottom: 0px;
}
.f25eUBXWNIVzAd {
  flex-shrink: 0;
  margin-bottom: 0;
  padding: 8px;
}
.qzn6ergg_M9Pzv {
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  padding: 0 0 4px 4px;
  cursor: pointer;
}
.GK6eVCOaMchzXe {
  flex-grow: 1;
  min-width: 0;
  margin-left: 12px;
}
.WzCz0XiIf4nMtR.selected {
  outline: var(--ds-border-focused, #388bff) auto 2px;
}
.mac .WzCz0XiIf4nMtR.selected {
  outline-color: -webkit-focus-ring-color;
}
.WzCz0XiIf4nMtR.selected .mac.firefox {
  outline-color: AccentColor;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelsList": `AEgIEBHcUVGEym`,
	"labelContainer": `dFag8JU1lt76jj`,
	"checkbox": `qzn6ergg_M9Pzv`,
	"editButton": `f25eUBXWNIVzAd`,
	"labelContent": `GK6eVCOaMchzXe`,
	"label": `WzCz0XiIf4nMtR`
};
export default ___CSS_LOADER_EXPORT___;
